import { render, staticRenderFns } from "./assignmentKsaReport.vue?vue&type=template&id=78f513ae&scoped=true&"
import script from "./assignmentKsaReport.vue?vue&type=script&lang=js&"
export * from "./assignmentKsaReport.vue?vue&type=script&lang=js&"
import style0 from "./assignmentKsaReport.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./assignmentKsaReport.vue?vue&type=style&index=1&id=78f513ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f513ae",
  null
  
)

export default component.exports